import Vue from 'vue'
import Vuex from 'vuex'
//base
import rootActions from './actions'
import rootMutations from './mutations'
import rootGetters from './getters'

import zendesk from './modules/zendesk/index.js'
import zdDevops from './modules/zendesk-devops/index.js'
import zdJira from './modules/zendesk-jira/index.js'
import zdGitHub from './modules/zendesk-github/index.js'
import zdAsana from './modules/zendesk-asana/index.js'
import monday from './modules/monday/index.js'
import mdDevops from './modules/monday-devops/index.js'
import mondayDevops from './modules/monday-devops/index.js'
//import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    //test:devops, incase namespaced:true then we need to use in this case test
    zendesk,
    zdDevops,
    zdJira,
    zdGitHub,
    zdAsana,
    monday,
    mdDevops,
    mondayDevops
  },
  state: {
    counter:0
    // put variables and collections here
  },
  
  mutations:rootMutations,// put sychronous functions for changing state e.g. add, edit, delete
  actions:rootActions,// put asynchronous functions that can call one or more mutation functions
  getters:rootGetters,
  strict: debug,
  plugins: []
  //plugins: debug ? [createLogger()] : []
})
//https://www.sitepoint.com/vuex-beginner-guide/